import { ProjectTypeDto } from '@cradua/data';
import { createReducer, on, Action } from '@ngrx/store';
import { EntityState, EntityAdapter, createEntityAdapter } from '@ngrx/entity';

import * as ProjectTypeActions from './project-type.actions';

export const PROJECT_TYPE_FEATURE_KEY = 'projecttype';

export interface ProjectTypeState extends EntityState<ProjectTypeDto> {
  selectedProjectTypeId?: string | number; // which ProjectType record has been selected
  loaded: boolean; // has the ProjectType list been loaded
  error?: string | null; // last none error (if any)
}

export interface ProjectTypePartialState {
  readonly [PROJECT_TYPE_FEATURE_KEY]: ProjectTypeState;
}

export const projectTypeAdapter: EntityAdapter<ProjectTypeDto> = createEntityAdapter<
  ProjectTypeDto
>({
  selectId: (projectType) => projectType.id,
  sortComparer: false,
});

export const initialState: ProjectTypeState = projectTypeAdapter.getInitialState(
  {
    // set initial required properties
    loaded: false,
    error: null,
    selectedProjectTypeId: null,
  }
);

const projectTypeReducer = createReducer(
  initialState,
  on(ProjectTypeActions.loadProjectType, (state) => ({
    ...state,
    loaded: true,
    error: null,
  })),
  on(ProjectTypeActions.loadProjectTypeSuccess, (state, { projectType }) =>
    projectTypeAdapter.addAll(projectType, { ...state, loaded: false })
  ),
  on(ProjectTypeActions.loadProjectTypeFailure, (state, { error }) => ({
    ...state,
    loaded: false,
    error,
  })),
  on(ProjectTypeActions.addProjectType, (state) => ({
    ...state,
    loaded: true,
    error: null,
  })),
  on(ProjectTypeActions.addProjectTypeSuccess, (state, { newProjectType }) =>
    projectTypeAdapter.addMany(newProjectType, { ...state, loaded: false })
  ),
  on(ProjectTypeActions.addProjectTypeFailure, (state, { error }) => ({
    ...state,
    loaded: false,
    error,
  })),
  on(ProjectTypeActions.updateProjectType, (state) => ({
    ...state,
    loaded: true,
    error: null,
  })),
  on(
    ProjectTypeActions.updateProjectTypeSuccess,
    (state, { updateProjectType }) =>
      projectTypeAdapter.upsertMany(updateProjectType, {
        ...state,
        loaded: false,
      })
  ),
  on(ProjectTypeActions.updateProjectTypeFailure, (state, { error }) => ({
    ...state,
    loaded: false,
    error,
  })),
  on(ProjectTypeActions.removeProjectType, (state) => ({
    ...state,
    loaded: true,
    error: null,
  })),
  on(ProjectTypeActions.removeProjectTypeSuccess, (state, { ids }) =>
    projectTypeAdapter.removeMany(ids, { ...state, loaded: false })
  ),
  on(ProjectTypeActions.removeProjectTypeFailure, (state, { error }) => ({
    ...state,
    loaded: false,
    error,
  }))
);

export function reducer(state: ProjectTypeState | undefined, action: Action) {
  return projectTypeReducer(state, action);
}
